import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, DEG_TO_RAD, Sprite, TextStyle, Text, NineSlicePlane, Point } from "pixi.js";
import tools from "tools";
export default class Btn2 extends Container {
  constructor(label, size, textColor, color, picto, backgroundSize = {
    width: 350,
    height: 80
  }, scale = 1) {
    super();
    this.onDown = this.onDown.bind(this);
    this.onUp = this.onUp.bind(this);
    this.onOut = this.onOut.bind(this);
    this._label = label;
    this._scale = scale;
    this._point = new Point();
    let btnTexture = assets.textures.basicWhiteBg.texture;
    this.btn = new NineSlicePlane(btnTexture, 30, 30, 30, 30);
    this.btn.tint = color;
    this.btn.width = backgroundSize.width;
    this.btn.height = backgroundSize.height;
    this.btn.x = -backgroundSize.width / 2;
    this.btn.y = -backgroundSize.height / 2;
    // this.addChild(this.btn);

    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', this.onDown);
    this.on('pointerup', this.onUp);
    this.on('pointerupoutside', this.onOut);
    this.on('pointermove', this._update);
    this.content = new Container();
    this.addChild(this.content);
    this.content.addChild(this.btn);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: size,
      align: "center",
      fill: textColor,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 4,
      dropShadowColor: '0x000000',
      dropShadowDistance: 6
    });
    this._text = new Text(label, textStyle);
    this._text.anchor.set(.5);
    this.content.addChild(this._text);
    if (picto) {
      let sprite = new Sprite(picto);
      sprite.anchor.set(.5);
      this._text.x = -sprite.width / 2;
      sprite.x = this._text.x + (this._text.width + sprite.width * .5) >> 1;
      sprite.y = -2;
      this.content.addChild(sprite);
    }
    this.scale.set(this._scale);
  }
  onDown(event) {
    if (!this._down) {
      this._down = true;
      gsap.to(this.scale, {
        duration: .2,
        x: this._scale - this._scale * .2,
        y: this._scale - this._scale * .2
      });
    }
  }
  onUp(event) {
    if (this._down) {
      gsap.to(this.scale, {
        duration: .2,
        x: this._scale,
        y: this._scale
      });
      this._callBack && this._callBack();
    }
    this._down = false;
  }
  onOut(event) {
    this._down = false;
    gsap.to(this.scale, {
      duration: .2,
      x: this._scale,
      y: this._scale
    });
  }
  _getMovement(posRef, point) {
    var directionX;
    var directionY;
    posRef.x1 = posRef.x2;
    posRef.x2 = point.x;
    directionX = point.x > posRef.x1 ? 1 : -1;
    posRef.y1 = posRef.y2;
    posRef.y2 = point.y;
    directionY = point.y > posRef.y1 ? 1 : -1;
    return {
      x: directionX * tools.distance({
        x: posRef.x1,
        y: 0
      }, {
        x: posRef.x2,
        y: 0
      }),
      y: directionY * tools.distance({
        x: 0,
        y: posRef.y1
      }, {
        x: 0,
        y: posRef.y2
      })
    };
  }
  _update() {
    this._pos = this._getMovement(this._point, config.mouse);
    if (Math.abs(this._pos.x) > 1 || Math.abs(this._pos.y) > 1) {
      this.onOut();
    }
  }
  animate() {
    gsap.to(this.content.scale, {
      duration: .3,
      x: 1.07,
      y: 1.07,
      repeat: -1,
      yoyo: true,
      yoyoEase: "none"
    });
  }
  set click(callBack) {
    this._callBack = callBack;
  }
  set text(val) {
    this._text.text = val;
  }
}
